<template>
    <ul>
        <li @click="changeLang('en')">
            <img :src="en_flag" />
        </li>
        <li @click="changeLang('cs')">
            <img :src="cs_flag" />
        </li>
        <li @click="changeLang('de')">
            <img :src="de_flag" />
        </li>
    </ul>
</template>

<script>
    import en_flag from '@/assets/img/en.png';
    import cs_flag from '@/assets/img/cs.png';
    import de_flag from '@/assets/img/de.png';

    export default {
        data() {
            return {
                en_flag,
                cs_flag,
                de_flag
            }
        },
        methods: {
            changeLang(lang) {
                this.$i18n.locale = lang;
            }
        }
    }
</script>

<style lang="scss" scoped>
    ul {
        list-style: none;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin: auto 0 20px 0;
    }
    ul img {
        display: block;
        width: 25px;
        height: 25px;
        margin: 5px 0;
        cursor: pointer;
    }
</style>